"use client"



import {store} from "@/core/redux/store";
import {Provider} from "react-redux";
import {PropsWithChildren} from "react";

export default function ProviderContainerComponent(props:PropsWithChildren){
    return(
        <Provider store={store}>
            {props.children}
        </Provider>
    )
}